// Partner-Pharmacies axios instance. Sends X-Auth-Token header on every request.
import axios from "axios";
import { toast } from "sonner";
import { getToken, clearToken } from "./authSession";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND}/api/pp`,
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers["X-Auth-Token"] = t;
  return config;
});

// Guard against re-entrant 401 storms — only one redirect per session.
let _redirecting = false;

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // 401 with detail mentioning "PIN" is an in-form authorisation failure
    // (record save or invoice upload) — NOT a session expiry. Let the caller
    // render an inline error without logging the user out.
    const detail = err?.response?.data?.detail;
    const isPinAuthFail =
      err?.response?.status === 401 &&
      typeof detail === "string" &&
      detail.toLowerCase().includes("pin");

    if (err?.response?.status === 401 && !isPinAuthFail && !_redirecting) {
      _redirecting = true;
      clearToken();
      if (typeof window !== "undefined") {
        try {
          toast.error("Session expired. Please sign in again.", {
            duration: 4000,
          });
        } catch { /* no-op */ }
        // Hard-navigate to the CRM path — the AuthGate will render because
        // sessionStorage no longer has a token. This also survives MemoryRouter.
        setTimeout(() => {
          window.location.href = "/pharmacy/partners";
        }, 400);
      }
    }
    return Promise.reject(err);
  },
);

// Anchor/iframe helper — append ?token= for endpoints that need it in URL
export const authedUrl = (path) => {
  const t = getToken();
  const sep = path.includes("?") ? "&" : "?";
  return `${BACKEND}/api/pp${path}${sep}token=${encodeURIComponent(t)}`;
};
